import { Row, Col, Form, Button } from 'react-bootstrap'
import InputMask from 'react-input-mask'
import useFormStore from '../stores/useFormStore'

function Associe() {
  const { setField } = useFormStore()
  const { setError } = useFormStore()

  const validateField = useFormStore(state => state.validateField)

  return (
    <Row>
      <Col xs={12} sm={12} md={12} lg={12} style={{ textAlign: 'center', fontSize: '30px', fontWeight: '700', padding: '20px' }}>
        <span>Proposta de Sócio</span>
      </Col>
      <Col xs={12} sm={12} md={12} lg={{ span: 10, offset: 1 }}>
        <Form>
          <Row style={{ border: '1px solid gray', padding: '20px', marginBottom: '20px' }}>
            <Col xs={12} sm={12} md={12} lg={12} className='text-center' style={{ fontSize: '24px', fontWeight: '700' }}>
              Dados pessoais
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Nome</Form.Label>
                <Form.Control
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Estado civil</Form.Label>
                <Form.Select aria-label="Default select example">
                  <option>Selecione uma opção</option>
                  <option value="1">Solteiro</option>
                  <option value="2">Casado</option>
                  <option value="3">Divorciado</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Data de nascimento</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='99/99/9999'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder='01/01/2000'
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Naturalidade</Form.Label>
                <Form.Control
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>CPF</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='999.999.999-99'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder='999.999.999-99'
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>RG</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='99.999.999-99'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder='99.999.999-99'
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Fone</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='(99) 99999-9999'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder='(99) 99999-9999'
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Email</Form.Label>
                <Form.Control
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row style={{ border: '1px solid gray', padding: '20px', marginBottom: '20px' }}>
            <Col xs={12} sm={12} md={12} lg={12} className='text-center' style={{ fontSize: '24px', fontWeight: '700' }}>
              Endereço
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>CEP</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='99999-999'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder='99999-999'
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={10}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Logradouro</Form.Label>
                <Form.Control
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={2}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Número</Form.Label>
                <Form.Control
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Bairro</Form.Label>
                <Form.Control
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Cidade</Form.Label>
                <Form.Control
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row style={{ border: '1px solid gray', padding: '20px', marginBottom: '20px' }}>
            <Col xs={12} sm={12} md={12} lg={12} className='text-center' style={{ fontSize: '24px', fontWeight: '700' }}>
              Dados profissionais
            </Col>
            <Form.Group className="mb-3" controlId=''>
              <Form.Label>Empresa</Form.Label>
              <Form.Control
                onChange={e => setField('properties.name', e.target.value)}
                onBlur={() => validateField('properties.validateType', 'properties.name')}
                required
                name=''
                placeholder=''
              />
              <Form.Control.Feedback type="invalid">
                Error
              </Form.Control.Feedback>
            </Form.Group>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Admissao na empresa</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='99/99/9999'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder='99/99/9999'
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Função</Form.Label>
                <Form.Control
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Ja foi sócio do sindicato?</Form.Label>
                <Form.Select aria-label="Default select example">
                  <option>Selecione uma opção</option>
                  <option value="1">Sim</option>
                  <option value="2">Não</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Data da filiação</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='99/99/9999'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder='99/99/9999'
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
          </Row>
          <Row style={{ border: '1px solid gray', padding: '20px', marginBottom: '20px' }}>
            <Col xs={12} sm={12} md={12} lg={12} className='text-center' style={{ fontSize: '24px', fontWeight: '700' }}>
              Dependentes
            </Col>
            <Col xs={12} sm={12} md={12} lg={12}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Tem dependentes?</Form.Label>
                <Form.Select aria-label="Default select example">
                  <option>Selecione uma opção</option>
                  <option value="1">Sim</option>
                  <option value="2">Não</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={2}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Parentesco</Form.Label>
                <Form.Select aria-label="Default select example">
                  <option>Selecione uma opção</option>
                  <option value="1">Conjuge</option>
                  <option value="2">Filho(a)</option>
                </Form.Select>
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={6}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Nome</Form.Label>
                <Form.Control
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder=''
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={3}>
              <Form.Group className="mb-3" controlId=''>
                <Form.Label>Data de nascimento</Form.Label>
                <Form.Control
                  as={InputMask}
                  mask='99/99/9999'
                  onChange={e => setField('properties.name', e.target.value)}
                  onBlur={() => validateField('properties.validateType', 'properties.name')}
                  required
                  name=''
                  placeholder='99/99/9999'
                />
                <Form.Control.Feedback type="invalid">
                  Error
                </Form.Control.Feedback>
              </Form.Group>
            </Col>
            <Col xs={12} sm={12} md={12} lg={1}>
              <Form.Group className="mb-3" controlId=''>
                Add
                <Button variant='success'>+</Button>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      </Col>
      <Col xs={12} sm={12} md={12} lg={{ span: 10, offset: 1 }} className='text-center' >
        <Row style={{ border: '1px solid gray', padding: '20px', marginBottom: '20px' }}>
          <Col xs={12} sm={12} md={12} lg={12} className='text-center' style={{ fontSize: '24px', fontWeight: '700' }}>
            Autorização
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <span>
              Autorizo a Firma Empregadora a descontar em folha de pagamento as mensalidades subsequentes, de acordo com o artigo 545 parágrafo único da CLT.
            </span>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <span>Empresa:</span>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            <span>Funcionário:</span>
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            Bauru __ de _______ de _____
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            ______________________________
          </Col>
          <Col xs={12} sm={12} md={12} lg={12}>
            Assinatura do sócio
          </Col>
        </Row>
      </Col>
      <Col xs={12} sm={12} md={12} lg={{ span: 4, offset: 4 }}>
        <Button variant='danger' style={{ width: '100%', marginTop: '20px' }}>Enviar</Button>
      </Col>
    </Row>
  )
}

export default Associe